import angular from "angular";
import modalSpecialHourSchedules from "./region-detail-modals/special-hour-schedule.html";

let RegionDetailController = function (
  $filter,
  $mdDialog,
  $scope,
  $state,
  Toast,
  Region
) {
  let $ctrl = this;

  $ctrl.id = $state.params.id;
  $ctrl.region;
  $ctrl.specialHours = [];
  $ctrl.events = [];
  $ctrl.specialHoursBody = {};
  $ctrl.isLoading = false;

  function DialogController($scope, $mdDialog, specialHours, idx) {
    "ngInject";

    if (specialHours) {
      $scope.specialHoursBody = {
        special_hours: angular.copy(specialHours.special_hours),
        name: specialHours.name,
        is_priority: specialHours.is_priority,
        id: specialHours.id,
      };

      $scope.specialHoursBody.special_hours.forEach((hour) => {
        hour.date = new Date(hour.date);
      });
    } else {
      $scope.specialHoursBody = {
        name: "",
        special_hours: [
          {
            date: new Date(),
            flag: false,
            description: "",
          },
        ],
      };
    }

    $scope.addOpeningHour = () => {
      $scope.specialHoursBody.special_hours.push({
        date: new Date(),
        flag: false,
        description: "",
      });
    };

    $scope.handleSpecialHoursDelete = (date) => {
      if (date.id) {
        Region.deleteSpecialHours(date)
          .then((response) => {
            loadResource($ctrl.id);
            $mdDialog.hide();
          })
          .catch((err) => {
            console.log("err:", err);
            $ctrl.uiState = "ERROR";
          });
      } else {
        _.remove($scope.specialHoursBody.special_hours, {
          $$hashKey: date.$$hashKey,
        });
      }
    };

    $scope.createOrEditSpecialHour = () => {
      saveSpecialHours(angular.copy($scope.specialHoursBody), idx);
      $mdDialog.hide();
    };
  }

  function sendSpecialHours(resource) {
    $ctrl.isLoading = true;
    Region.createSpecialHours(resource, $ctrl.id || $ctrl.region.id)
      .then((response) => {
        $ctrl.specialHoursBody = { name: "", special_hours: [] };
      })
      .catch((err) => {
        console.log("err:", err);
        $ctrl.uiState = "ERROR";
      })
      .finally(() => {
        $ctrl.isLoading = false;
        $ctrl.id
          ? loadResource($ctrl.id || $ctrl.region.id)
          : $state.go("region.list");
      });
  }

  $ctrl.resource = null;
  function saveSpecialHours(resource, idx=null) {
    if (resource.length) {
      $ctrl.resource = angular.copy(resource);
    } else {
      $ctrl.resource = resource.id
        ? angular.copy(resource)
        : [angular.copy(resource)];
    }

    if ($ctrl.id) {
      sendSpecialHours($ctrl.resource);
    } else {
      const dates = resource.special_hours.map((date) => {
        return date.date;
      });
      const orderedDates = dates.sort(function (a, b) {
        return Date.parse(a) - Date.parse(b);
      });

      const event = {
        name: resource.name,
        first_date: orderedDates[0],
        last_date: orderedDates[orderedDates.length - 1],
        days: resource.special_hours.length,
        special_hours: angular.copy(resource.special_hours),
      };

      if((typeof idx) === 'number') {
        $ctrl.specialHours[idx] = angular.copy(event)
        $ctrl.events[idx] = angular.copy(resource)

      }
      else{
        $ctrl.specialHours.push(event);
        $ctrl.events.push(resource);
      }
    }
  }

  $scope.showPrerenderedDialog = function (ev, resource, idx = null) {
    $ctrl.selectedSpecialHour = resource;

    $mdDialog.show({
      controller: DialogController,
      bindToController: true,
      template: modalSpecialHourSchedules,
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose: true,
      locals: { specialHours: angular.copy(resource), idx: idx },
    });
  };

  angular.extend($ctrl, {
    clearForm,
    handleSave,
    handleDelete,
    formatDate,
  });

  activate();

  function activate() {
    clearForm();
    loadResource($ctrl.id);
  }

  function clearForm(form) {
    $ctrl.region = {};

    if (form) {
      form.$setPristine();
      form.$setUntouched();
    }
  }

  function handleDelete(region, event) {
    let confirmMessage = "region-detail-delete-confirm-text";

    let confirm = $mdDialog
      .confirm()
      .textContent($filter("translate")(confirmMessage))
      .ariaLabel($filter("translate")(confirmMessage))
      .targetEvent(event)
      .ok($filter("translate")("common-yes"))
      .cancel($filter("translate")("common-cancel"));

    $mdDialog
      .show(confirm)
      .then(() => {
        $ctrl.deleting = true;
        Region.destroy(region)
          .then((response) => {
            Toast.success($filter("translate")("region-detail-delete-success"));
            $ctrl.deleting = false;
            $state.go("region.list");
          })
          .catch((err) => {
            Toast.error($filter("translate")("common-server-error"));
            console.log("err:", err);
            $ctrl.deleting = false;
          });
      })
      .catch(() => {});
  }

  function handleSave(form, region) {
    if (!form.$valid) {
      Toast.error($filter("translate")("common-form-incomplete"));
      return;
    }

    save(region);
  }
  $ctrl.getDates = function (special_hours) {
    const dates = (special_hours.special_hours || special_hours).map(special_hour => {
      return $ctrl.formatDate(special_hour.date)
    })
    return dates
  }

  // Local functions
  function loadResource(id) {
    if (id) {
      $ctrl.uiState = "LOADING";

      Region.show(id)
        .then((response) => {
          $ctrl.region = response;
          $ctrl.uiState = "COMPLETE";
        })
        .catch((err) => {
          console.log("err:", err);
          $ctrl.uiState = "ERROR";
        })
        .finally(() => {
          $ctrl.isLoading = true;

          Region.getSpecialHours(id)
            .then((response) => {
              $ctrl.specialHours = response;
              $ctrl.isLoading = false;
            })
            .catch((err) => {
              console.log("err:", err);
              $ctrl.uiState = "ERROR";
            })
            .finally(()=> $ctrl.uiState = "COMPLETE")
        });
    } else {
      $ctrl.uiState = "COMPLETE";
    }
  }

  function loadDomainResources() {
    $ctrl.uiState = "LOADING";

    let promises = [];

    promises.push(Module.index());

    return Promise.all(promises);
  }

  function save(region) {
    $ctrl.saving = true;

    Region.save(region)
      .then((response) => {
        Toast.success($filter("translate")("region-detail-save-success"));
        $ctrl.region = response;
        $ctrl.saving = false;
      })
      .catch((err) => {
        let defaultErrMsg = "common-server-error";
        let fourONineMsg = "region-detail-409-error";
        let message = err.status == 409 ? fourONineMsg : defaultErrMsg;
        Toast.error($filter("translate")(message));
        console.log("err:", err);
        $ctrl.saving = false;
      })
      .finally(() => {
        if (!$ctrl.id) {
          sendSpecialHours($ctrl.events);
        } else {
          $state.go("region.list");
        }
      });
  }

  function formatDate(date) {
    return new Intl.DateTimeFormat(navigator.language).format(new Date(date));
  }
};

RegionDetailController.$inject = [
  "$filter",
  "$mdDialog",
  "$scope",
  "$state",
  "Toast",
  "Region",
];

export default RegionDetailController;



// WEBPACK FOOTER //
// ./client/app/components/region/region-detail.controller.js